import React, { useMemo } from "react";

export default function Footer() {
  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <div
      className="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop"
      id="kt_footer"
    >
      <div className="kt-container">
        <div className="kt-footer__copyright">
          {year}&nbsp;&copy;&nbsp; Rodic Davidson
        </div>
        <div className="kt-footer__menu">
          <a
            href="https://orbn.atlassian.net/servicedesk/customer/portal/1"
            target="_blank"
            rel="noopener noreferrer"
            className="kt-footer__menu-link kt-link"
          >
            Support Portal
          </a>
          <a
            href="https://stats.uptimerobot.com/rgpOxFAkX4"
            target="_blank"
            rel="noopener noreferrer"
            className="kt-footer__menu-link kt-link"
          >
            Status
          </a>
        </div>
      </div>
    </div>
  );
}
